export class PaymentLookupRequestBuilder {
    constructor() {
        this.properties = {};
    }
    static validateRequest(request) {
        if (!request) {
            throw new Error("Missing payment lookup request");
        }
        if (!request.id) {
            throw new Error("Missing vehicle ID in payment lookup request");
        }
        if (!request.duration || request.duration < 1) {
            throw new Error("Missing month duration in payment lookup request");
        }
        if (!request.downPayment || request.downPayment < 1) {
            throw new Error("Missing cash deposit in payment lookup request");
        }
    }
    forVehicle(id) {
        this.properties.id = id;
        return this;
    }
    forDealer(id) {
        this.properties.branchId = id;
        return this;
    }
    withDuration(duration) {
        this.properties.duration = duration;
        return this;
    }
    withDownPayment(downPayment) {
        this.properties.downPayment = downPayment;
        return this;
    }
    withResidualValue(residual) {
        this.properties.residual = residual;
        return this;
    }
    build() {
        return this.properties;
    }
}
